import * as React from "react";
import AppBar from "@mui/material/AppBar";
import { Box, Divider, Toolbar, Typography } from "@mui/material";
import Container from "@mui/material/Container";
import Button from "@mui/material/Button";
import { NavLink } from "react-router-dom";

import Logo from "./Logo";
import UserNav from "./UserMenu";
import PageLinks from "./PageLinks";

const userPages = ["scenarios"]; // , 'Resources', 'Statistics'

export default function HeaderShell(props) {
  const label = "account";
  const link = (props) => <NavLink to={"/" + label} {...props} />;
  return (
    <AppBar position="static" sx={{ boxShadow: 0, backgroundColor: "#fff" }}>
      <Container maxWidth={"xl"}>
        <Toolbar
          disableGutters
          sx={{
            justifyContent: "space-between",
            borderBottom: 1,
            borderBottomColor: "grey.medium",
            height: "84px",
          }}
        >
          <Box display="flex" sx={{ alignItems: "center" }}>
            <Logo />
            <Typography variant="h6" color="grey.main" textAlign="center">
              {label}
            </Typography>
          </Box>
          <Box display="flex" sx={{ alignItems: "center" }}>
            <PageLinks pages={userPages} />
            <UserNav />
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  );
}
